export const environment = {
    production: false,
    apiUrl: 'https://resultsharness-stg.transnetyx.com/api',
    seqApiUrl: 'https://sequencing-stg.transnetyx.com/api/admin/internal/mock-data',

    auth0: {
        domain: 'login-stg.transnetyx.com',
        clientId: 'qdqo60w5vxo9CcrpHBqurrx7sORedI8P',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-stg.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login-stg.transnetyx.com/v2/logout',
    },

    omUrl: 'http://ordermanager-stg.transnetyx.com/Default.aspx',
    omOrderResultsUrl: 'https://ordermanager-stg.transnetyx.com/Orders/OrderResults.aspx?OrderId=',
    seqOrderDetailsPageUrl: 'https://yxadmin-stg.transnetyx.com/sequencing/orders/details/',
};
